module.exports = __webpack_public_path__ + "img/information_technology_thumbnail-600x450.ff536760.jpg";